<script>
import Layout from "@layouts/form";
import Parametro from "@forms/Parametro";

export default {
  page: {
    title: "Detalhes | Parâmetro"
  },
  components: { Layout, Parametro },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Parâmetro",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Parâmetro",
          href: "/Parametro"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Parametro :editable="editable"></Parametro>
    </div>
  </Layout>
</template>
